<div class="fixed inset-0 z-[9999] bg-white/60 flex items-center justify-center">
  <mat-spinner diameter="48"></mat-spinner>
</div>
